enum KeyCodes {
  Enter = 13,
  Escape = 27,
  Up = 38,
  Down = 40,
}

export default KeyCodes;
